export default "__VITE_ASSET__D10GJ3E6__"